export * from 'server/models/MorePage';


// WEBPACK FOOTER //
// ./data/models/MorePage.ts